import App from "./App";
import { Suspense, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Helmet } from "react-helmet-async";
import { Routes, Route } from "react-router-dom";
import LandingPage from "./components/LandingPage";

export default function LanguageWrapper() {
    const { lang } = useParams();
    const { i18n } = useTranslation();

    useEffect(() => { if (lang) { i18n.changeLanguage(lang); } }, [lang, i18n]);

    const baseUrl = "https://b-ride-volt.ge";

    const seoLang =
        lang === "geo"
            ? "ka"
            : lang || "en";
    const getCanonical = () => {
        switch (lang) {
            case "ru":
                return `${baseUrl}/ru`;
            case "geo":
                return `${baseUrl}/geo`;
            case "en":
            default:
                return baseUrl;
        }
    };


    const getDescription = () => {
        switch (seoLang) {
            case "ru":
                return "Прокат велосипедов и электровелосипедов в Боржоми и Бакуриани. Доставка в отель и горные маршруты.";
            case "ka":
                return "ველოსიპედების და ელექტრო ველოსიპედების გაქირავება ბორჯომსა და ბაკურიანში. სასტუმროში მიწოდება და ტურები.";
            case "en":
            default:
                return "Rent bikes and e-bikes in Borjomi and Bakuriani. Premium CUBE mountain bikes, hotel delivery, and scenic routes in Georgia mountains.";
        }
    };

    const getTitle = () => {
        switch (seoLang) {
            case "ru":
                return "Прокат велосипедов в Боржоми | Электровелосипеды и горные велосипеды";
            case "ka":
                return "ველოსიპედების გაქირავება ბორჯომში | ელექტრო და მთის ველოსიპედები";
            case "en":
            default:
                return "Bike Rental in Borjomi | Rent E-Bikes & Mountain Bikes in Georgia";
        }
    };
    return (
        <Suspense fallback={null}>
            <Helmet>
                <html lang={seoLang} />
                <title>{getTitle()}</title>
                <meta name="description" content={getDescription()} />
                <meta property="og:url" content={getCanonical()} />
                <meta property="og:title" content={getTitle()} />
                <meta property="og:description" content={getDescription()} />
                <meta property="og:type" content="website" />
                
                <link rel="canonical" href={getCanonical()} />

                <link rel="alternate" hreflang="en" href={`${baseUrl}/`} />
                <link rel="alternate" hreflang="ru" href={`${baseUrl}/ru`} />
                <link rel="alternate" hreflang="ka" href={`${baseUrl}/geo`} />
                <link rel="alternate" hreflang="x-default" href={`${baseUrl}/`} />
            </Helmet>
             <Routes>
                <Route path="/" element={<App />} />
                <Route path="bike-rental-borjomi" element={<LandingPage />} />
            </Routes>
        </Suspense>
    );
}